import { render, staticRenderFns } from "./DefaultForm.vue?vue&type=template&id=2fca7d36&scoped=true"
import script from "./DefaultForm.vue?vue&type=script&lang=ts"
export * from "./DefaultForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca7d36",
  null
  
)

export default component.exports